/* Así funciona · Aspiradora Vertical de Mano con Extensor (1664464)
   La sala real de la foto de ambiente (piso de baldosa). La clienta toma la aspiradora vertical REAL (recortada de la
   misma foto) por el cepillo y la pasa por una mancha de polvo y motas del piso: la aspiradora se desliza sobre el
   piso con la escala de la perspectiva (horizonte de la lechada real), su sombra de contacto la acompaña y la sombra
   que dejaba en la pared se va al sacarla de ahí. Las motas que alcanza el borde del cepillo vuelan hacia la boca y el
   piso queda limpio detrás (la baldosa real). Dentro del depósito TRANSPARENTE real se ve el polvo girando y
   acumulándose abajo. Al final: el depósito de cerca y la misma aspiradora de mano (la real, apoyada en la pared).
   Todo lo de alrededor es la misma foto sin la vertical (fondo.py, sin IA): pared fila por fila, zócalo continuado,
   baldosa real con su lechada continuada. La mugre: el mismo piso más opaco + motas reales de las fotos.
   Ficha: de mano o vertical con 2 tubos de extensión, depósito transparente de 0,7 L, cepillo de piso, boquilla 2 en 1
   y filtro. Piezas: tiendas/nayhogar/funciona/aspiradora-vertical-de-mano-con-extensor/hacer.py */
NHF.escena('aspiradora-vertical-de-mano-con-extensor', function (E) {
  const D = /*DATOS*/{"fondo":"fn-aspiradora-vertical-de-mano-con-extensor-fondo.webp","vertical":{"src":"fn-aspiradora-vertical-de-mano-con-extensor-vertical.webp","caja":[429,222,693,1284]},"sombra_pared":{"src":"fn-aspiradora-vertical-de-mano-con-extensor-sombra-pared.webp","caja":[715,231,837,1124]},"sombra_piso":{"src":"fn-aspiradora-vertical-de-mano-con-extensor-sombra-piso.webp","caja":[421,1346,589,195]},"horizonte":570.0,"huella":[[446,1400],[732,1448],[726,1498],[442,1446]],"ancla":[587.0,1448.0],"zona":[[560,1398],[800,1398],[865,1430],[865,1532],[505,1532],[490,1470],[530,1420]],"vaso":{"pol":[[958,449],[1027,482],[1016,520],[999,558],[990,578],[979,586],[955,580],[931,573],[921,568],[923,548],[941,500]],"fondo":586,"tope":470},"motas":{"src":"fn-aspiradora-vertical-de-mano-con-extensor-motas.webp","n":40,"cel":24,"cols":8},"polvo":{"src":"fn-aspiradora-vertical-de-mano-con-extensor-polvo.webp","caja":[917.0,445.0,114.0,145.0]},"suciedad":{"src":"fn-aspiradora-vertical-de-mano-con-extensor-suciedad.webp","caja":[441,1399,458,182]},"rejilla":{"g":8,"w":58,"h":23,"v":"00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000012210000000000000000000000000000000000000000000001112210023443100001110000111000000000000000000000000111002333565434556432112333212356410000000000000000000000023332344578877777876544455555678873100000000000000000000001244445678888888888876566677888886310000000000000000000000013444578888888888888654444567764310000000000000000000001113554358888888888888864322233443110000000000000000001001345787645788888888888886543333444433210000000000000000222456788887776788888887778887666556666542100000000000000023345567888877666655567777888888876667764200000000000000001122332478866788753345666678888887656776420000000000012111111232247886678886545554446888888754455531000000000012334443333346788777888875565443577776543111232000001222124555677776534788887788887568876677643211100001000000234335778888888874468888888888778888888875200000000000000024656788888888888656888888888888888888888742100000000000013788888888888888876567767766677778888888776421000000000002588888888888877777655543454445544688887544543100000000000257888877777655554444442111221112236876310122100000000000023456543444322221001122100000000011354210000000000000000000111110012210001000000000000000000001000000000000000000000000000000000000000000000000000000000000000000000000000000"}}/*FIN*/;
  const movil = () => window.innerWidth < 760;
  const S = E.lienzo({ w: 1600, h: 1600, vista: [0, 150, 1600, 1450], vistaMovil: [330, 150, 1060, 1450] });
  E.titulo('Pásala y [mira el depósito].', 'Arrastra el cepillo por el polvo del piso: lo que recoge se ve en su depósito transparente.');
  E.conSonido();
  S.cargando(true);

  const A0 = D.ancla, YH = D.horizonte, SC = D.suciedad.caja, V = D.vertical.caja, VS = D.vaso;
  S.img(D.fondo, null, { z: 1, alt: 'Sala con piso de baldosa y la aspiradora de mano apoyada en la pared' });
  const sucio = S.canvas(SC, { z: 2, res: 1 });
  const sPared = S.img(D.sombra_pared.src, D.sombra_pared.caja, { z: 3 });
  const sPiso = S.img(D.sombra_piso.src, D.sombra_piso.caja, { z: 4, pivote: A0 });
  const VU = [SC[0] - 80, SC[1] - 120, SC[2] + 160, SC[3] + 130];
  const vuelo = S.canvas(VU, { z: 5 });
  const asp = S.grupo(V, { z: 6, pivote: A0 });
  S.img(D.vertical.src, V, { en: asp, alt: 'Aspiradora vertical con su depósito transparente' });
  const xsV = VS.pol.map(p => p[0]), ysV = VS.pol.map(p => p[1]);
  const VC = [Math.min(...xsV) - 4, Math.min(...ysV) - 4, Math.max(...xsV) - Math.min(...xsV) + 8, Math.max(...ysV) - Math.min(...ysV) + 8];
  const vaso = S.canvas(VC, { en: asp, res: 2 });
  let imgSucio = null, imgMotas = null, imgPolvo = null;
  E.cargar([D.fondo, D.vertical.src, D.suciedad.src, D.motas.src, D.sombra_pared.src, D.sombra_piso.src, D.polvo.src]).then(r => {
    imgSucio = r[2]; imgMotas = r[3]; imgPolvo = r[6]; pintarSucio(); S.cargando(false);
  });

  /* ---------- panel ---------- */
  const top = E.el('div', 'av-top'); E.panel.prepend(top); top.style.marginBottom = '16px';
  const modo = E.seg([{ id: 'vertical', texto: 'Vertical' }, { id: 'mano', texto: 'De mano' }], m => ponerModo(m), { etiqueta: 'Cómo usarla', en: top });
  E.pasos(['Pasa el cepillo por el polvo del piso', 'Mira el depósito transparente', 'Úsala de mano: toca «De mano»']);
  E.paso(0);
  const fila = E.el('div', 'av-fila'); E.ctrls.appendChild(fila);
  fila.style.cssText = 'display:flex;gap:28px;flex-wrap:wrap;width:100%';
  const lPiso = E.lectura({ etiqueta: 'Piso limpio', en: fila }); lPiso.poner('0', '%');
  const lDep = E.lectura({ etiqueta: 'Depósito', en: fila }); lDep.poner('0,7 L', 'transparente');
  fila.querySelectorAll('.nhf-lectura__v').forEach(v => { v.style.fontSize = 'clamp(30px,3.4vw,44px)'; });
  const bAuto = E.boton('Pásala por mí', () => autoPasar(), { icono: 'mano' });
  const NOTA = 'Depósito transparente de 0,7 L. Trae 2 tubos de extensión, cepillo de piso, boquilla 2 en 1 y filtro.';
  E.nota(NOTA);

  /* ---------- geometría: la aspiradora se desliza por el piso con la escala de la perspectiva ---------- */
  const P = { x: A0[0], y: A0[1] };
  let rot = 0;
  const escala = y => (y - YH) / (A0[1] - YH);
  function mapearEn(p, px, py, r) { // punto de la foto (aspiradora en su sitio) -> lienzo con la aspiradora en (px,py)
    const s = escala(py), a = (r || 0) * Math.PI / 180, c = Math.cos(a), si = Math.sin(a);
    const x = (p[0] - A0[0]) * s, y = (p[1] - A0[1]) * s;
    return [px + x * c - y * si, py + x * si + y * c];
  }
  function aplicar() {
    const s = escala(P.y), dx = P.x - A0[0], dy = P.y - A0[1];
    const t = 'translate3d(' + dx.toFixed(2) + 'px,' + dy.toFixed(2) + 'px,0) rotate(' + rot.toFixed(3) + 'deg) scale(' + s.toFixed(4) + ')';
    asp.style.transform = t; sPiso.style.transform = t;
    // la sombra que la vertical dejaba en la pared se va apenas la separas de la pared
    sPared.style.opacity = Math.max(0, 1 - Math.hypot(dx, dy) / 70).toFixed(3);
  }
  const Z = D.zona;
  function dentro(pol, x, y) {
    let c = false;
    for (let i = 0, j = pol.length - 1; i < pol.length; j = i++) {
      const [xi, yi] = pol[i], [xj, yj] = pol[j];
      if (((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) c = !c;
    }
    return c;
  }
  function limitar(x, y) { // dentro de la zona del piso libre (punto más cercano del borde si se sale)
    if (movil()) x = Math.min(x, 775); // en el celular el mango no se sale del cuadro
    if (dentro(Z, x, y)) return { x, y };
    let best = null, bd = 1e9;
    for (let i = 0; i < Z.length; i++) {
      const a = Z[i], b = Z[(i + 1) % Z.length], vx = b[0] - a[0], vy = b[1] - a[1];
      const k = E.clamp(((x - a[0]) * vx + (y - a[1]) * vy) / (vx * vx + vy * vy), 0, 1);
      const qx = a[0] + vx * k, qy = a[1] + vy * k, d = Math.hypot(x - qx, y - qy);
      if (d < bd) { bd = d; best = { x: qx, y: qy }; }
    }
    return best;
  }

  /* ---------- la mugre: capa real que el cepillo borra; rejilla para saber cuánto falta ---------- */
  const R = D.rejilla, G = R.g;
  const rest0 = Float32Array.from(R.v.split('').map(c => +c / 9));
  let rest = rest0.slice(), total = rest0.reduce((a, b) => a + b, 0), quitado = 0;
  function pintarSucio() {
    sucio.limpiar(); sucio.el.style.opacity = 1;
    if (imgSucio) sucio.ctx.drawImage(imgSucio, SC[0], SC[1], SC[2], SC[3]);
  }
  function borrar(pol, suave) {
    const c = sucio.ctx, off = 5000;
    c.save(); c.globalCompositeOperation = 'destination-out';
    c.shadowColor = '#000'; c.shadowBlur = (suave || 4) * sucio.res; c.shadowOffsetX = off * sucio.res;
    c.beginPath(); pol.forEach((p, i) => i ? c.lineTo(p[0] - off, p[1]) : c.moveTo(p[0] - off, p[1])); c.closePath(); c.fill();
    c.restore();
  }
  function celdasEn(pol, cb) {
    const xs = pol.map(p => p[0]), ys = pol.map(p => p[1]);
    const i0 = Math.max(0, Math.floor((Math.min(...xs) - SC[0]) / G)), i1 = Math.min(R.w - 1, Math.floor((Math.max(...xs) - SC[0]) / G));
    const j0 = Math.max(0, Math.floor((Math.min(...ys) - SC[1]) / G)), j1 = Math.min(R.h - 1, Math.floor((Math.max(...ys) - SC[1]) / G));
    for (let j = j0; j <= j1; j++) for (let i = i0; i <= i1; i++) {
      const k = j * R.w + i;
      if (rest[k] > 0 && dentro(pol, SC[0] + (i + .5) * G, SC[1] + (j + .5) * G)) cb(k, SC[0] + (i + .5) * G, SC[1] + (j + .5) * G);
    }
  }
  const huellaEn = (px, py, r) => D.huella.map(p => mapearEn(p, px, py, r));

  /* ---------- motas que el cepillo alcanza: vuelan hacia la boca (debajo del cepillo) ---------- */
  const vuelan = [];
  let recoge = 0; // "succión" reciente (para el polvo que gira en el depósito y el sonido)
  function sellar(x0, y0, x1, y1) {
    const d = Math.hypot(x1 - x0, y1 - y0), n = Math.max(1, Math.ceil(d / 5));
    const ux = d > 0.01 ? (x1 - x0) / d : 0, uy = d > 0.01 ? (y1 - y0) / d : 0;
    let antes = quitado;
    for (let i = 1; i <= n; i++) {
      const px = x0 + (x1 - x0) * i / n, py = y0 + (y1 - y0) * i / n;
      const pol = huellaEn(px, py, rot);
      borrar(pol);
      celdasEn(pol, k => { quitado += rest[k]; rest[k] = 0; });
    }
    // lo que está justo delante del borde del cepillo se va hacia la boca
    if (d > 0.01) {
      const s = escala(y1), adel = huellaEn(x1 + ux * 22 * s, y1 + uy * 22 * s, rot);
      const boca = mapearEn(A0, x1, y1, rot);
      let nuevas = 0;
      celdasEn(adel, (k, cx, cy) => {
        if (nuevas > 3 || Math.random() > 0.5) return;
        nuevas++;
        quitado += rest[k]; rest[k] = 0;
        const jx = (Math.random() - .5) * G, jy = (Math.random() - .5) * G * .5;
        borrar([[cx + jx - 5, cy + jy - 3], [cx + jx + 5, cy + jy - 3], [cx + jx + 5, cy + jy + 3], [cx + jx - 5, cy + jy + 3]], 3);
        vuelan.push({ x: cx + jx, y: cy + jy, bx: boca[0], by: boca[1], t: 0, dur: .16 + Math.random() * .16, m: Math.floor(Math.random() * D.motas.n), sz: (.32 + Math.random() * .22) * s });
      });
    }
    if (quitado > antes) recoge = Math.min(1, recoge + (quitado - antes) * 0.08);
  }
  function pintarVuelo(dt) {
    vuelo.limpiar();
    if (!imgMotas) return;
    const c = vuelo.ctx, M = D.motas;
    for (let i = vuelan.length - 1; i >= 0; i--) {
      const p = vuelan[i]; p.t += dt;
      const k = Math.min(1, p.t / p.dur);
      if (k >= 1) { vuelan.splice(i, 1); continue; }
      const e = k * k * k; // arranca despacio y acelera hacia la boca (succión)
      const x = p.x + (p.bx - p.x) * e, y = p.y + (p.by - p.y) * e - Math.sin(k * Math.PI) * 6;
      const w = M.cel * p.sz * (1 - .35 * k);
      const sx = (p.m % M.cols) * M.cel, sy = Math.floor(p.m / M.cols) * M.cel;
      c.globalAlpha = 1 - .5 * k;
      c.drawImage(imgMotas, sx, sy, M.cel, M.cel, x - w / 2, y - w / 2, w, w);
    }
    c.globalAlpha = 1;
  }

  /* ---------- depósito transparente real: el polvo gira (ciclón) y se junta abajo ---------- */
  let nivel = 0, nivelVis = 0;
  const giran = [];
  const ejeA = [996, 462], ejeB = [958, 598]; // eje real del vaso (arriba -> abajo)
  function pintarVaso(dt) {
    const c = vaso.ctx; vaso.limpiar();
    nivelVis += (nivel - nivelVis) * Math.min(1, dt * 3);
    c.save();
    c.beginPath(); VS.pol.forEach((p, i) => i ? c.lineTo(p[0], p[1]) : c.moveTo(p[0], p[1])); c.closePath(); c.clip();
    if (nivelVis > 0.002 && imgPolvo) {
      const yN = VS.fondo + (VS.tope - VS.fondo) * nivelVis;
      // polvo acumulado (pelusa y motas reales), con la orilla de arriba irregular; el nivel queda horizontal
      c.save();
      c.beginPath(); c.moveTo(VC[0] - 2, VS.fondo + 8);
      for (let x = VC[0] - 2; x <= VC[0] + VC[2] + 2; x += 3) c.lineTo(x, yN + Math.sin(x * .23) * 1.5 + Math.sin(x * .61 + 1) * 1.1);
      c.lineTo(VC[0] + VC[2] + 2, VS.fondo + 8); c.closePath(); c.clip();
      const PC = D.polvo.caja;
      c.drawImage(imgPolvo, PC[0], PC[1], PC[2], PC[3]);
      c.restore();
    }
    // el ciclón: motas que giran alrededor del eje del vaso mientras aspira y van bajando
    if (imgMotas && recoge > 0.05 && giran.length < 14 && Math.random() < recoge * .6) giran.push({ a: Math.random() * 6.28, h: .05 + Math.random() * .25, w: 7 + Math.random() * 5, m: Math.floor(Math.random() * D.motas.n), s: .2 + Math.random() * .14, t: 0 });
    const M = D.motas;
    for (let i = giran.length - 1; i >= 0; i--) {
      const q = giran[i]; q.t += dt; q.a += q.w * dt; q.h += dt * .5;
      const fin = 1 - nivelVis * 1.05;
      if (q.h > fin || q.t > 2.2) { giran.splice(i, 1); continue; }
      const cx = ejeA[0] + (ejeB[0] - ejeA[0]) * q.h, cy = ejeA[1] + (ejeB[1] - ejeA[1]) * q.h;
      const r = 30 - q.h * 6, x = cx + Math.cos(q.a) * r * .96, y = cy + Math.cos(q.a) * r * .27 + Math.sin(q.a) * 5;
      const w = M.cel * q.s * (Math.sin(q.a) > 0 ? 1 : .8);
      c.globalAlpha = Math.sin(q.a) > 0 ? .78 : .38; // detrás del filtro se ve menos
      c.drawImage(imgMotas, (q.m % M.cols) * M.cel, Math.floor(q.m / M.cols) * M.cel, M.cel, M.cel, x - w / 2, y - w / 2, w, w);
    }
    c.globalAlpha = 1;
    c.restore();
  }

  /* ---------- arrastrar el cepillo (la clienta "toma" la aspiradora por el cepillo) ---------- */
  const HB = D.huella, hx = HB.map(p => p[0]), hy = HB.map(p => p[1]);
  const agarre = S.toque([Math.min(...hx) - 40, Math.min(...hy) - 110, Math.max(...hx) - Math.min(...hx) + 80, Math.max(...hy) - Math.min(...hy) + 150], { en: asp, etiqueta: 'Cepillo de la aspiradora: arrástralo por el piso', clase: 'av-agarre' });
  agarre.style.touchAction = 'none'; agarre.style.cursor = 'grab';
  agarre.classList.add('is-pista');
  let arr = null, meta = null, ruta = null, quieto = 0, empezo = false, fase = 0, volviendo = false;
  agarre.addEventListener('pointerdown', e => {
    if (fase === 1) return;
    e.preventDefault(); const p = S.punto(e);
    arr = { ox: P.x - p.x, oy: P.y - p.y }; ruta = null; volviendo = false; empezar();
    try { agarre.setPointerCapture(e.pointerId); } catch (x) {}
    agarre.style.cursor = 'grabbing';
  });
  agarre.addEventListener('pointermove', e => { if (!arr) return; const p = S.punto(e); meta = limitar(p.x + arr.ox, p.y + arr.oy); });
  const soltar = () => { arr = null; meta = null; agarre.style.cursor = 'grab'; };
  agarre.addEventListener('pointerup', soltar); agarre.addEventListener('pointercancel', soltar);
  agarre.addEventListener('keydown', e => {
    const m = { ArrowLeft: [-30, 0], ArrowRight: [30, 0], ArrowUp: [0, -18], ArrowDown: [0, 18] }[e.key];
    if (!m || fase === 1) return; e.preventDefault(); empezar();
    const q = limitar(P.x + m[0], P.y + m[1]); ruta = [[q.x, q.y]];
  });
  // tocar el piso: la aspiradora va hasta ahí
  const zx = Z.map(p => p[0]), zy = Z.map(p => p[1]);
  const piso = S.toque([Math.min(...zx) - 170, Math.min(...zy) - 60, Math.max(...zx) - Math.min(...zx) + 340, Math.max(...zy) - Math.min(...zy) + 120], { z: 5, etiqueta: 'Piso: toca para llevar la aspiradora', alTocar: e => { if (fase === 1) return; const p = S.punto(e); const q = limitar(p.x, p.y + 20); empezar(); ruta = [[q.x, q.y]]; } });
  piso.style.touchAction = 'pan-y';
  function empezar() {
    if (!empezo) { empezo = true; agarre.classList.remove('is-pista'); S.pista('Pásala por toda la mancha', 'mano'); }
    E.noListo();
  }
  function autoPasar() {
    if (fase === 1) return;
    if (modo) { modo.elegir('vertical'); ponerModo('vertical'); }
    empezar(); bAuto.hidden = true;
    const xm = movil() ? 775 : 850;
    ruta = [[620, 1462], [xm, 1466], [xm, 1505], [520, 1500], [505, 1528], [xm, 1530], [xm, 1430], [640, 1416], [600, 1440]];
  }

  /* ---------- motor (sonido, si la clienta lo prende) ---------- */
  let motor = null;
  function sonar(v) {
    if (!E.sonido.activo) { if (motor) { motor.parar(); motor = null; } return; }
    if (v > 0.02 && !motor) motor = E.sonido.ruido(0, 0.02, 1400);
    if (motor) { motor.volumen(0.012 + 0.03 * v); motor.filtro(1100 + 900 * recoge); }
    if (v <= 0.02 && motor && quieto > 0.7) { motor.parar(); motor = null; }
  }

  /* ---------- bucle ---------- */
  E.bucle((t, dt) => {
    const x0 = P.x, y0 = P.y;
    if (meta) {
      const k = 1 - Math.exp(-dt * 14); P.x += (meta.x - P.x) * k; P.y += (meta.y - P.y) * k;
    } else if (ruta && ruta.length) {
      const [tx, ty] = ruta[0], d = Math.hypot(tx - P.x, ty - P.y), v = 560 * dt;
      if (d <= v) { P.x = tx; P.y = ty; ruta.shift(); if (!ruta.length) { ruta = null; volviendo = false; } } else { P.x += (tx - P.x) / d * v; P.y += (ty - P.y) / d * v; }
    }
    const vx = (P.x - x0) / Math.max(dt, 1e-3), mov = Math.hypot(P.x - x0, P.y - y0);
    // el palo se inclina un poco hacia donde la empujas (giro sobre el cepillo); quieta = la foto exacta
    const rMeta = E.clamp(vx * 0.0035, -2, 2);
    rot += (rMeta - rot) * Math.min(1, dt * 7);
    if (Math.abs(rot) < 0.002 && !mov) rot = 0;
    quieto = mov > 0.2 ? 0 : quieto + dt;
    if (mov > 0.2 && fase === 0 && !volviendo) sellar(x0, y0, P.x, P.y);
    aplicar();
    recoge = Math.max(0, recoge - dt * 0.9);
    pintarVuelo(dt);
    pintarVaso(dt);
    sonar(Math.min(1, mov / Math.max(dt, 1e-3) / 600));
    if (fase === 0 && total > 0) {
      const pct = Math.min(100, quitado / total * 100);
      lPiso.poner(String(Math.floor(pct >= 93 ? 100 : pct)), "%");
      nivel = Math.min(1, quitado / total) * 0.24;
      if (pct >= 93 && !vuelan.length) terminar();
    }
  });

  /* ---------- final: el depósito de cerca y de mano ---------- */
  async function terminar() {
    fase = 1; arr = null; meta = null; ruta = null; bAuto.hidden = true;
    // lo poquito que quede se recoge en el último pase
    await E.animarP(500, k => { sucio.el.style.opacity = (1 - k).toFixed(3); });
    lPiso.poner('100', '%');
    if (motor) { motor.parar(); motor = null; }
    E.paso(1); S.pista('Mira el polvo en el depósito transparente', 'toca');
    lDep.poner('0,7 L', 'ves cuándo vaciarlo');
    const c = mapearEn([975, 530], P.x, P.y, rot);
    await S.camara(movil() ? [c[0] - 210, c[1] - 200, 420, 420] : [c[0] - 330, c[1] - 230, 660, 480], 1100);
    await E.esperar(2200);
    await S.camara(null, 1000);
    fase = 2; E.paso(2);
    S.pista('Ahora toca «De mano»', 'toca');
    modo.querySelector('[data-v="mano"]').style.boxShadow = '0 0 0 2px var(--sage)';
  }
  function ponerModo(m) {
    modo.elegir(m);
    if (m === 'mano') {
      modo.querySelector('[data-v="mano"]').style.boxShadow = '';
      if (fase === 1) return;
      arr = null; meta = null;
      if (Math.hypot(P.x - A0[0], P.y - A0[1]) > 1) { ruta = [[A0[0], A0[1]]]; volviendo = true; }
      S.camara(movil() ? [860, 660, 400, 560] : [700, 600, 760, 640], 1000);
      S.pista('Sin los tubos queda de mano', 'toca');
      E.nota('Sin los tubos queda de mano: con su cepillo o la boquilla 2 en 1, para el sofá y el carro.');
      if (fase === 2) { E.paso(3); E.listo('Vertical para el piso y de mano para el sofá y el carro. El depósito transparente te muestra cuándo vaciarlo.', reiniciar); }
    } else {
      S.camara(null, 900); E.nota(NOTA);
      if (fase === 0) S.pista(empezo ? 'Pásala por toda la mancha' : 'Arrastra el cepillo por el polvo', 'mano');
    }
  }
  function reiniciar() {
    E.noListo(); fase = 0; empezo = false; arr = null; meta = null;
    rest = rest0.slice(); quitado = 0; nivel = 0; vuelan.length = 0; giran.length = 0;
    pintarSucio(); lPiso.poner('0', '%'); lDep.poner('0,7 L', 'transparente');
    modo.elegir('vertical'); S.camara(null, 900); E.nota(NOTA); E.paso(0); bAuto.hidden = false;
    ruta = [[A0[0], A0[1]]]; volviendo = true;
    agarre.classList.add('is-pista'); S.pista('Arrastra el cepillo por el polvo', 'mano');
  }
  aplicar();
  S.pista('Arrastra el cepillo por el polvo', 'mano');
});
